import { z } from 'zod';
import { subscriptionBillingCadenceSchema } from './subscriptionBillingCadence.js';
import { MAXIMUM_FREE_DAYS } from './subscriptionConfiguration.js';
// A revocation has to happen before the following interval after which the cancellation executes.
export const CANCELLATION_REVOKE_MARGIN_IN_MINUTES = 30;
export const subscriptionActionSchema = z.enum([
    'SchedulePlanChange',
    'RevokePlanChange',
    'GrantFreeTime',
    'RevokeFreeTime',
    'RequestCancellation',
    'RevokeCancellation',
    // Ends the subscription immediately.
    'Terminate',
]);
export const SubscriptionAction = subscriptionActionSchema.enum;
export const subscriptionActionBlockerSchema = z.enum([
    'NotRunning',
    // Card and TWINT are cancelled in Stripe, which we then sync.
    'ManagedInStripe',
    'WithinCreditsCoverage',
    // The invoice path, which has no Stripe subscription attached.
    'NotOnStripe',
    'CancellationScheduled',
    'PlanChangeScheduled',
    // Booked for a boundary that has not been met, so it can be revoked and a new one granted.
    'FreeTimePending',
    // Running right now, so the days are already consumed and nothing can be granted or taken back.
    'FreeTimeRunning',
    'NextTermAlreadyBilled',
    'NoFutureBoundary',
    'NothingScheduled',
    'TooLateToRevoke',
]);
export const SubscriptionActionBlocker = subscriptionActionBlockerSchema.enum;
export const subscriptionActionStateSchema = z.object({
    available: z.boolean(),
    blockedBy: subscriptionActionBlockerSchema.nullable(),
});
export const subscriptionActionsSchema = z.record(subscriptionActionSchema, subscriptionActionStateSchema);
export const schedulePlanChangeSchema = z.object({
    planId: z.number().int().positive(),
    billingCadence: subscriptionBillingCadenceSchema.optional(),
    comment: z.string().optional(),
});
export const grantFreeTimeSchema = z.object({
    days: z.int().min(1).max(MAXIMUM_FREE_DAYS),
    comment: z.string().optional(),
});
export const requestCancellationSchema = z.object({
    comment: z.string().optional(),
});
export const terminateSubscriptionSchema = z.object({
    comment: z.string().optional(),
});
